export class paymentDetails{
    public membershipFee:string = "";
    public cgst:string = "";
    public sgst:string = "";
    public igst:string = "";
    public admissionFee:string = "";
}